export class PNRFlightModel {
  departureFlight;
  returnFlight;
  valuePoints;
  valueCurrency;
}

export class PNRItemModel {
  pnrId;
  pnrNumber;
  pnrDate;
  principalContact;
  passengers;
  payment;
  cart;
  cancelInfo;
  passengerCancelInfo;
  status;
  statusTicketTicket;
  statusAntiFraud;
  fareOriginType;
  totalPointPaymentAdicional;
  totalValuePaymentAdicional;
  totalTxEmbarque;
  partnerPnrMap;
}

export const Status = {
  ACTIVE: 'ACTIVE',
  CANCEL_IN_PROGRESS: 'CANCEL_IN_PROGRESS',
  CANCELED: 'CANCELED',
  FLOWN: 'FLOWN',
  REALLOCATION: 'REALLOCATION'
};

export const FareOriginType = {
  PUBLIC: 'PUBLIC',
  AWARD: 'AWARD'
};

export const StatusTicket = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  CANCEL_BY_FRAUD: 'CANCEL_BY_FRAUD',
  REFUND: 'REFUND',
  AMENDED: 'AMENDED',
  FLOWN: 'FLOWN',
  ALERT: 'ALERT'
};



// WEBPACK FOOTER //
// ./src/const/PNRItemModel.js